import React, { useState } from 'react';
import ParentCardNoCol from '../../../common/ParentCardNoCol';
import { Form, Formik } from 'formik';
import { lableForDatePatters, settingDates } from '../../../../common/custom/date-data';
import CustomInputWithIcon from '../../../../common/ui/CustomInputWithIcon';
import { drapcodeIcon } from '../../../../common/custom/icon-library';
import CustomSelect from '../../../../common/formElements/CustomSelect';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
export const DateFormat = ({ projectId, version, dateFormat, updateDateFormat, toggle }) => {
  const [defaultDateFormat, setDefaultDateFormat] = useState(
    dateFormat ? dateFormat : 'YYYY-MM-DD',
  );
  const formatOptions = settingDates.map((option) => ({
    value: option,
    label: lableForDatePatters(option),
  }));

  const handleSubmit = (values) => {
    const { dateFormat } = values;
    updateDateFormat({ dateFormat, projectId, version });
  };

  return (
    <ParentCardNoCol title="Date Format" icon="dateFormat" bgColor="drapcode-violet">
      <Formik
        initialValues={{
          dateFormat: defaultDateFormat,
        }}
        onSubmit={handleSubmit}
      >
        {({ isSubmitting, setFieldValue, setFieldTouched, resetForm, errors }) => {
          return (
            <Form className="form-horizontal">
              <div className="row mx-auto">
                <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                  <CustomInputWithIcon title="Name" icon="text" required={true}>
                    <CustomSelect
                      name="dateFormat"
                      isMulti={false}
                      onChange={setFieldValue}
                      onChangeValue={(name, value) => setDefaultDateFormat(value)}
                      onBlur={setFieldTouched}
                      options={formatOptions}
                      value={defaultDateFormat}
                      placeholder="Select Date Format"
                    />
                  </CustomInputWithIcon>
                </div>
                <div className="col-md-12 col-lg-12 mt-2 text-right  d-flex justify-content-between">
                  <Link
                    to={`/app-setting/${version}/v/${projectId}/setting/appConstant`}
                    className="btn btn-outline btn-md"
                  >
                    <i className="wb webconnect-times"></i> Cancel
                  </Link>

                  <button type="submit" className="btn btn-theme-submit btn-md">
                    <i className={`wb ${drapcodeIcon('save')}`}></i>&nbsp;Update&nbsp;
                  </button>
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
    </ParentCardNoCol>
  );
};
